export const actionsConfig = [
  {
    id: "tomar",
    label: "Tomar Solicitud",
    button: "Solucinar",
    url: "/v1/helpdesk/tomarcaso",
    type: "PUT",
    fields: [
      { name: "prioridad", label: "Prioridad", type: "select2", id:"show"},
      { name: "accion", type: "hidden", id: "tomar_caso", value: "Tomar Caso" },
      { name: "description", label: "Descripción", type: "textarea", id:"show"}
    ] 
  },{
    id: "solucionar",
    label: "Solucionar Solicitud",
    status: 3,
    url: "/v1/helpdesk/solucionarcaso",
    type: "PUT",
    fields: [
      { name: "fecha_cierre", label: "Fecha Cierre", type: "date", id:"show"},
      { name: "description", label: "Descripción", type: "textarea", id:"show"},
      { name: "accion", type: "hidden", id: "hide", value: "Solucion Caso" },
      { name: "evidence", label: "Adjunto", type: "file", id:"show"}
    ] 
  },{
    id: "cancelar",
    label: "Cancelar Solicitud",
    status: 4,
    url: "/v1/helpdesk/cancelarcaso",
    type: "PUT",
    fields: [
      { name: "accion", type: "hidden", id: "cancelar_caso", value: "Cancelar Caso" },
      { name: "description", label: "Descripción", type: "textarea", id:"show"}
    ] 
  },{
    id: "reasignar",
    label: "Reasignar Solicitud",
    url: "/v1/helpdesk/reasignarcasouser",
    type: "PUT",
    fields: [
      { name: "user_caso", label: "Seleccione Usuario", type: "select", id:"show"},
      { name: "prioridad", label: "Seleccione Prioridad", type: "select2", id:"hide"},
      { name: "accion", type: "hidden", id: "reasignar_caso", value: "Reasignar Caso" },
      { name: "description", label: "Descripción", type: "textarea", id:"show"}
    ] 
  },{
    id: "comentar",
    label: "Agregar Comentario",
    url: "/v1/helpdesk/comentario",
    type: "POST",
    fields: [
      { name: "accion", type: "hidden", id: "Comentario", value: "Comentario" },
      { name: "description", label: "Descripción", type: "textarea", id:"show"}
    ] 
  },{
    id: "cotizar",
    label: "Realizar cotizacion",
    status: 5,
    url: "/v1/helpdesk/cotizar",
    type: "PUT",
    fields: [
      { name: "accion", type: "hidden", id: "cotizar_Caso", value: "Cotizar Caso" },
      { name: "description", label: "Descripción", type: "textarea", id:"show"}
    ] 
  }
]